// La connexion et ce qui l'entoure : l'écran de connexion, l'invitation, le
// refus d'accès. Les deux premiers s'affichent AVANT qu'on sache si
// l'organisation a l'anglais : ils suivent la langue du navigateur.
export default {
  langue: 'Langue',
  passerEnClair: 'Passer en clair',
  passerEnSombre: 'Passer en sombre',
  seConnecter: 'Se connecter',
  login: {
    adresse: 'Adresse',
    exempleAdresse: "vous{'@'}exemple.fr",
    motDePasse: 'Mot de passe',
    enCours: 'Connexion…',
    navigationEchouee: 'Connexion réussie, mais la navigation a échoué : {erreur}. Rechargez la page.',
    note: "Les accès sont accordés par un administrateur, et entrent dans votre session à la connexion : une permission accordée à l'instant demande de se reconnecter.",
  },
  invitation: {
    chargement: 'Chargement…',
    indisponible: 'Invitation indisponible',
    titre: 'Invitation',
    rejoindre: 'Rejoindre {organisation}',
    choisirMotDePasse: 'Choisissez un mot de passe',
    encore: 'Encore : {manques}',
    confirmer: 'Confirmez-le',
    unInstant: 'Un instant…',
    sessionOuverte: 'Session ouverte avec {email}. Connectez-vous avec l’adresse invitée.',
    votreMotDePasse: 'Votre mot de passe Orion',
    seConnecterEtRejoindre: 'Se connecter et rejoindre {organisation}',
    doitContenir: 'Le mot de passe doit contenir : {manques}.',
    differents: 'Les deux mots de passe ne sont pas identiques.',
    // Ce que `manquesMotDePasse` (@orion/domain/equipe) rend, par règle.
    manques: {
      longueur: '12 caractères',
      minuscule: 'une minuscule',
      majuscule: 'une majuscule',
      chiffre: 'un chiffre',
      symbole: 'un symbole',
    },
  },
  acces: {
    titre: 'Accès non autorisé',
    demande: "Cet écran demande la permission {module}, que ce compte n'a pas.",
    refuse: "Ce compte n'a pas la permission d'ouvrir cet écran.",
    ceCompte: 'Ce compte',
    modulesAccordes: 'Modules accordés',
    aucun: 'Aucun. L’administrateur de votre organisation vous les attribue depuis la page Équipe.',
    seReconnecter: 'Se reconnecter',
    retour: 'Retour',
  },
}
